import { FreeMode } from 'swiper/modules'
import tabs from '../../modules/tabs'
import notificacaoService from '../services/notificacao.service'
import queryString from 'query-string'
import NotificationItem from './NotificationItem'
import Swiper from 'swiper'
import EmptyItem from './EmptyItem'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const { api, errorDefault, getTipoPaginaAtual } = GLOBAL

const { getAllNotifications } = notificacaoService()

let intervalAgendaNotificacoes = null

const notificacoesOpcoes = {
	todas: null,
	operações_internas: [
		'Prospect',
		'Efetivação de prospect',
		'Ativos sem categoria',
		'Finalização de Atendimento',
		'Finalização de Tarefa',
	],
	atendimento: [
		'Cliente sem atendimento recente',
		'Fundação sem atendimento recente',
	],
	alertas_financeiros: [
		'Cliente não coberto pelo FGC',
		'Cliente com emissores não cobertos pelo FGC',
		'Queda de rentabilidade',
		'Rentabilidade abaixo do benchmark',
	],
	agenda_outlook: ['Lembrete de Evento no Outlook'],
}

export default {
	props: ['open', 'js-tab'],
	emits: ['close', 'update', 'add-notification'],
	components: { NotificationItem, EmptyItem },
	// Estados reativos (ou iniciais)
	data() {
		return {
			totalNotificationsTab: 0,
			activeTabAtendimento: 'todas',
			swiperTabsFiltro: null,
			animation: null,
			notifications: {
				data: [],
				loading: false,
			},
			idLastNotification: null,
			tabsNotificacao: [
				{ id: 'todas', title: 'Todas' },
				{ id: 'atendimento', title: 'Atendimento' },
				{ id: 'operações_internas', title: 'Operações Internas' },
				{ id: 'alertas_financeiros', title: 'Alertas Financeiros' },
				{ id: 'agenda_outlook', title: 'Agenda Outlook' },
			],
			queryNotification: {
				tipo_notificacao: null,
				page: 1,
				page_size: 10,
				total_items: 0,
				has_next: false,
			},
		}
	},

	// metodo que observa mudanças (onchange)
	watch: {
		open() {
			if (!this.open) {
				console.log('ta fechado 🍃')
				this.notifications.data = this.notifications.data.map(
					(i) => (i.visto = true) && i
				)
				const ids = this.notifications.data.map((i) => i.id)
				axios.post('core/limpar_notificacoes/', ids)
				this.$emit('update', false)
				this.agendarNotification(15000)
			} else {
				if (intervalAgendaNotificacoes) {
					clearInterval(intervalAgendaNotificacoes)
				}
			}
		},

		notifications() {
			if (this.notifications.data.filter((i) => !i.visto)?.length) {
				this.$emit('update', true)
			} else {
				this.$emit('update', false)
			}
		},
	},

	// Métodos do componente
	methods: {
		handleClose() {
			this.activeTabAtendimento = 'todas'
			this.resetQueryNotification()
			this.$emit('close', false)
		},

		// async getLastNotification() {
		// 	const { data } = await api.get('/api/notificacao/?ultima=1')
		// 	return data[0];
		// },

		async updateStatusViewedNotifications(arr) {
			try {
				const update = await axios.put('/api/notificacao/', arr)
				this.compareStateWithLastNotification()
			} catch (err) {
				console.log(err)
			}
		},

		async fetchNotifications({ reset = false, interval = false } = {}) {
			this.notifications.loading = true
			try {
				let { tipo_notificacao, page, page_size } = this.queryNotification

				if (Array.isArray(tipo_notificacao)) {
					tipo_notificacao = tipo_notificacao.join(',')
				}

				const tipoPagina = GLOBAL.getTipoPaginaAtual?.()
				
				const tipo_cliente =
					tipoPagina === 'fundacao'
						? 'sai'
						: tipoPagina === 'cliente_pf'
						? 'sap'
						: null

				const response = await getAllNotifications({
					tipo_notificacao,
					page,
					page_size,
					tipo_cliente,
				})

				if (interval && this.notifications.data !== response.results) {
					console.log('Tem, notificacao ai ')
				}

				this.queryNotification = response?.pagination
					? {
							page: response.pagination.page,
							page_size: response.pagination.page_size,
							total_items: response.pagination.total_items,
							has_next: response.pagination.has_next,
							tipo_notificacao: this.queryNotification.tipo_notificacao,
					  }
					: this.queryNotification

				if (reset) {
					this.notifications.data = response?.results || []
				} else {
					this.notifications.data.push(...(response?.results || []))
				}

				this.$nextTick(() => {
					this.totalNotificationsTab = response?.count || 0
				})
			} catch (e) {
				console.error(e)
			} finally {
				this.notifications.loading = false
			}
		},

		async getTodasNotificacoes(interval) {
			// Mantido para compatibilidade, mas agora chama o método novo
			await this.fetchNotifications({ reset: true, interval })
		},

		async onloadMoreNotification(index, done) {
			if (!this.queryNotification.has_next) {
				if (done) done()
				return
			}
			this.queryNotification.page += 1
			await this.fetchNotifications({ reset: false })
			if (done) done()
		},

		isNotificacaoDaPaginaAtual(notificacao) {
			const tipoPagina = getTipoPaginaAtual()
			if (notificacao.fundacao_id && tipoPagina === 'fundacao') return true
			if (notificacao.cliente_pf_id && tipoPagina === 'cliente_pf') return true
			if (
				!notificacao.fundacao_id &&
				!notificacao.cliente_pf_id &&
				tipoPagina === 'geral'
			)
				return true

			return false
		},

		onEnter(el, done) {
			//Executando animação no modal

			this.initSwiperTabsFiltro()

			this.animation = gsap
				.timeline()
				.set(el, { opacity: 0, translateY: -25 })
				.set(document.querySelector('.background-deep'), { opacity: 0 })
				.to(el, { opacity: 1, translateY: 0, duration: 0.35 }, 'rodaJunto')
				.to(
					document.querySelector('.background-deep'),
					{ opacity: 1 },
					'rodaJunto'
				)
				.add(() => tabs())

			done()
		},

		leave(el, done) {
			this.resetQueryNotification()

			this.getTodasNotificacoes()
			this.animation
				.timeScale(2)
				.reverse()
				.then((result) => done())
		},

		async compareStateWithLastNotification() {
			const lastNotification = await this.getLastNotification()

			if (lastNotification.id !== this.$data.idLastNotification.id) {
				document.body.style.setProperty('--notificacao', '#C11F39')
				this.getTodasNotificacoes()
			}
		},

		onUpdateStateNotificationWithApi(data) {
			let pagination = { ...data.pagination }

			pagination.total_items = data?.results?.length
			pagination.num_pages = Math.ceil(
				data?.results?.length / data.pagination.page_size
			)
			pagination.has_next =
				data.pagination.page < pagination.num_pages ? true : false

			return {
				data: data?.results || [],
				pagination: { ...pagination },
			}
		},

		agendarNotification(interval) {
			if (intervalAgendaNotificacoes) {
				clearInterval(intervalAgendaNotificacoes)
			}
			intervalAgendaNotificacoes = setInterval(() => {
				this.getTodasNotificacoes()
			}, interval)
		},

		onClickNotification(notification) {
			this.$emit('add-notification', notification)
			this.$emit('close', false)
		},

		async onClickTabNotificationFilter(tabId) {
			const tabName = tabId.toLowerCase()

			if (this.activeTabAtendimento.toLowerCase() === tabName) return

			this.activeTabAtendimento = tabId

			const abaNotificacaoSelect = Object.keys(notificacoesOpcoes).some(
				(key) => key.toLowerCase() === tabName
			)

			if (!abaNotificacaoSelect) {
				errorDefault('Filtro de notificação inválido')
				return
			}

			this.queryNotification.tipo_notificacao = notificacoesOpcoes[tabName]
			this.queryNotification.page = 1
			this.queryNotification.page_size = 10

			await this.getTodasNotificacoes()

			this.$nextTick(() => {
				const container = document.querySelector('.tabs-content')
				if (container) container.scrollTop = 0
			})
		},

		initSwiperTabsFiltro() {
			this.$nextTick(() => {
				this.swiperTabsFiltro = new Swiper('.swiper', {
					modules: [FreeMode],
					freeMode: {
						enabled: true,
						sticky: true,
						momentum: true,
						momentumBounce: true,
					},
					spaceBetween: 16,
					slidesPerView: 'auto',
					slideToClickedSlide: true,
				})
			})
		},

		resetQueryNotification() {
			this.queryNotification = {
				tipo_notificacao: null,
				page: 1,
				page_size: 10,
				total_items: 0,
				has_next: false,
			}
		},
	},

	// utils do componente
	computed: {
		get() {},
		textTooltipButtoneEdit() {},
		totalItemsByTab() {
			return this.queryNotification?.total_items || 0
		},
	},

	// Executa assim que o componenete é criado no dom
	// Executa um cado antes do mounted
	created() {},

	// Executa assim que o componente é montado
	async mounted() {
		await this.getTodasNotificacoes()
		this.agendarNotification(15000)

		/* interval = setInterval(() => {
			this.getTodasNotificacoes(true)
		}, 15000) */

		// this.idLastNotification = await this.getLastNotification();

		// this.compareStateWithLastNotification();

		// const callNotification = () => {
		// 	setTimeout(async () => {
		// 		await this.compareStateWithLastNotification();
		// 		callNotification();
		// 	}, 10000);
		// }
		// callNotification();

		// 1ounce que vai bater nessa rota de notificacao
		// com um filtro
		// dentro da resposta vc vai pegar e salvar o dado

		// no proximo request vc vai verificar se a dado é igual a dado anterior

		// se nao for vc roda get all notifications
		// e roda tambem uma funcao pra deixar o icone vermelho

		// quando abrir a notificacao, vc vai setar tudo como visto
		// enviar em um patch

		// observar o array pra ver se tem algum nao lido e deixar vermelho
	},

	//Executa um pouco antes de desmontar o componente
	beforeUnmounted() {},
	// Executa ao desmontar o componente
	unmounted() {},

	template: /* html */ `
    <Transition @enter="onEnter" @leave="leave">
        <section v-if="open" class="w-[39.75rem]  h-[calc(100vh-4rem-18px)] rounded-md absolute overflow-hidden z-[9999999999999999999999] top-[4rem] right-64">
            <header
                class="flex items-center justify-between px-24 pt-24 pb-16 bg-primary-pure relative z-[9999]"
            >
            <h2 class="text-lg font-medium text-white">Notificações</h2>
                <button
                    type="button"
                    class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10"
                    data-xclose="modal_padrao"
                    @click="handleClose"
                >
                    <svg class="w-32 h-32">
                        <use xlink:href="#icon_close"></use>
                    </svg>
                </button>
            </header>
            <div class="p-24 bg-white h-full relative z-[9999]">
                <div class="flex flex-col !w-full h-full">
					<div class="swiper flex flex-col !w-full">
						<ul class="swiper-wrapper flex border-b !border-none max-h-max">
							<li 
								v-for="tab in tabsNotificacao" 
								:key="tab.id" 
								data-tab="tab-modal-1" 
								:data-notification-filter="tab.id"	
								class="swiper-slide relative gap-8 tab-item !flex-[0] whitespace-nowrap tab-item-primary"
								:class="{'active': activeTabAtendimento.toLowerCase() === tab.id.toLowerCase() }" 
								@click="onClickTabNotificationFilter(tab.id)">
								{{ tab.title }} <span v-if="activeTabAtendimento === tab.id" class="block px-8 ml-6 text-sm font-medium rounded-full badge-container bg-neutral-30 text-neutral-70">{{totalNotificationsTab || 0}}</span>
							</li>
						</ul>
					</div>
                    <div class="flex flex-col h-full overflow-auto tabs-content !mt-24">
                        <div class="tab-collapse active" data-tab="tab-modal-1">
                            <div class="relative flex-1 tab-container pb-80" >
							<!--Temporario-->
							<q-infinite-scroll  :offset="10" debounce="300" @load="onloadMoreNotification">
                                <div class="flex flex-col gap-8 mt-8" :value="notification.id" v-for="notification in notifications.data"  :class="{'nao-visto': !notification.visto}">
									<NotificationItem
										:key="notification.id"
										:notification="notification"
										@onClickNotification="onClickNotification"
									/>
                                </div>
								 
								
								 <template v-slot:loading>
									<div class="row justify-center q-my-md">
									<q-spinner-dots color="primary" size="40px" />
									</div>
								</template>
								
							</q-infinite-scroll>

							<div v-if="notifications?.data?.length === 0 && !notifications.loading" class="flex flex-1 items-center justify-center h-full">
								<EmptyItem text="Nenhuma notificação encontrada." classP="text-xl"/>
							</div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    </Transition>

		<Teleport to="body" v-if="open" >
				<div class="background-deep fixed left-0 top-0 bg-[rgba(0,0,0,0.25)] w-[100vw] h-[100vh] z-[999]"
						@click="handleClose"
				></div>
		</Teleport>

    `,
}
